
export default {
    name: 'OrderchampLogo',
}
